module.exports = __webpack_public_path__ + "13d5276968b2bdba1c6d83dbc4892cc6.svg";